/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'ホーム',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/president_greeting',
    name: '代表 ご挨拶',
    meta: { title: '代表 ご挨拶', desc: '代表 ご挨拶。' },
    component: () => import('../views/PresidentGreeting.vue')
  },
  {
    path: '/staff_voice',
    name: 'スタッフの声',
    meta: { title: 'スタッフの声', desc: 'スタッフの声。' },
    component: () => import('../views/StaffVoice.vue')
  },
  {
    path: '/business',
    name: '事業内容',
    meta: { title: '事業内容', desc: '事業内容。' },
    component: () => import('../views/Business.vue')
  },
  {
    path: '/company',
    name: '会社情報',
    meta: { title: '会社情報', desc: '会社情報。' },
    component: () => import('../views/Company.vue')
  },
  {
    path: '/news',
    name: '新着情報',
    meta: { title: '新着情報', desc: '新着情報。' },
    component: () => import('../views/News.vue')
  },
  {
    path: '/news/:id',
    name: '新着情報詳細',
    meta: { title: '新着情報詳細', desc: '新着情報詳細。' },
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/electronics',
    name: '電子部品',
    meta: { title: '電子部品', desc: '電子部品。' },
    component: () => import('../views/Electronics.vue')
  },
  {
    path: '/electronics_focus',
    name: '注目の電子部品',
    meta: { title: '注目の電子部品', desc: '注目の電子部品。' },
    component: () => import('../views/ElectronicsFocus.vue')
  },
  {
    path: '/search',
    name: '電子部品 在庫検索',
    meta: { title: '電子部品 在庫検索', desc: '電子部品 在庫検索。' },
    component: () => import('../views/Search.vue')
  },
  {
    path: '/networking',
    name: '光通信関連部品',
    meta: { title: '光通信関連部品', desc: '光通信関連部品。' },
    component: () => import('../views/Networking.vue')
  },
  {
    path: '/opt_stock',
    name: '光通信部品在庫一覧',
    meta: { title: '光通信部品在庫一覧', desc: '光通信部品在庫一覧。' },
    component: () => import('../views/OptStock.vue')
  },
  {
    path: '/attenuator',
    name: '光アッテネーター',
    meta: { title: '光アッテネーター', desc: '光アッテネーター。' },
    component: () => import('../views/Attenuator.vue')
  },
  {
    path: '/opt_search',
    name: '光パッチコード在庫検索',
    meta: { title: '光パッチコード在庫検索', desc: '光パッチコード在庫検索。' },
    component: () => import('../views/OptSearch.vue')
  },
  {
    path: '/opt_custom_order',
    name: '光パッチコードカスタムオーダー',
    meta: { title: '光パッチコードカスタムオーダー', desc: '光パッチコードカスタムオーダー。' },
    component: () => import('../views/OptCustomOrder.vue')
  },
  {
    path: '/adapter',
    name: '光アダプタ',
    meta: { title: '光アダプタ', desc: '光アダプタ。' },
    component: () => import('../views/Adapter.vue')
  },
  {
    path: '/opt_connector',
    name: '光コネクタ',
    meta: { title: '光コネクタ', desc: '光コネクタ。' },
    component: () => import('../views/OptConnector.vue')
  },
  {
    path: '/maker',
    name: '取引メーカー',
    meta: { title: '取引メーカー', desc: '取引メーカー。' },
    component: () => import('../views/Maker.vue')
  },
  {
    path: '/accessories',
    name: 'アクセサリ',
    meta: { title: 'アクセサリ', desc: 'アクセサリ。' },
    component: () => import('../views/Accessories.vue')
  },
  {
    path: '/toiawase',
    name: 'お問い合わせ',
    meta: { title: 'お問い合わせ', desc: 'お問い合わせ。' },
    component: () => import('../views/Toiawase.vue')
  },
  {
    path: '/accessmap',
    name: 'アクセスマップ',
    meta: { title: 'アクセスマップ', desc: 'アクセスマップ。' },
    component: () => import('../views/AccessMap.vue')
  },
  {
    path: '/component',
    name: '精密切削加工',
    meta: { title: '精密切削加工', desc: '精密切削加工。' },
    component: () => import('../views/Component.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0, left: 0 }
  },
  routes
})

export default router